import { PlayerRatingScope, PlayerIdentity } from "components/ReviewAudit/PublicRatings"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Container, Card, CardBody, Button } from "reactstrap"
import { Link, useLocation } from "react-router-dom"
import { useToasts } from "react-toast-notifications"
import ListenerComponent from "components/Common/Socket/ListenerComponent"
import * as actions from "./actions"
import ActionLogs from "./ActionLogs"
import AppliedChanges from "./AppliedChanges"
import Administration from "./Administration"
import { MatchParticipants, ResultStatus, friendlyDate, friendlyId, matchFormat, matchStatus } from "./MatchSummary"
import { matchPeople } from "./MatchSummary"
import "./friendlyMatches.scss"

const loadErrorMessage = error => {
  if (error?.response?.status === 404) return "Match not found."
  if (error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT") return "The server did not respond in time."
  return "Match could not be loaded."
}

const Details = ({ getFriendlyMatch, friendlyMatchesState, match: { params } }) => {
  useEffect(() => { getFriendlyMatch(params.id) }, [getFriendlyMatch, params.id])
  const returnTo = useLocation().state?.friendlyMatchesReturnTo
  const backTo = /^\/friendly-matches(?:\?|$)/.test(returnTo || "") ? returnTo : "/friendly-matches"
  const { addToast } = useToasts()
  const { friendlyMatch: match = {}, loading, error } = friendlyMatchesState
  const listenForResponse = ({ success, message }) => {
    if (success) getFriendlyMatch(params.id)
    addToast(message, { appearance: success ? "success" : "error", autoDismiss: true })
  }
  const ready = !loading && !error && String(match._id) === params.id
  const fields = ready ? [
    [match.pastMatch ? "Match date" : "Match date and time", friendlyDate(match.startDate, match.timezone, !match.pastMatch)],
    ["Location", [match.location?.name, match.location?.city, match.location?.country].filter(Boolean).join(", ") || "Location unavailable"],
    ["Sport / Game type", `${match.sportType || "Unavailable"} / ${match.gameType || "Unavailable"}`],
    ["Match type", match.ranked === true ? "Ranked" : match.ranked === false ? "Unranked" : "Unavailable"],
    ["Format", matchFormat(match.format)],
    ["Created", friendlyDate(match.createdAt, "UTC")],
    ["Score added / updated", friendlyDate(match.scoreAddedDate, "UTC")],
    ["Entered as a played match", match.pastMatch === true ? "Yes" : match.pastMatch === false ? "No" : "Not recorded"],
  ] : []
  return <PlayerRatingScope players={ready ? matchPeople(match) : []}><div className="page-content fm-page"><Container fluid>
    <ListenerComponent listenFunction={listenForResponse} topic="friendly-matches-response" />
    <Link to={backTo} className="d-inline-block mb-3">Friendly Matches</Link>
    <Card><CardBody>
      {(loading || (!ready && !error)) && <p role="status">Loading match…</p>}
      {error && <div role="alert" className="alert alert-danger">{loadErrorMessage(error)} <Button onClick={() => getFriendlyMatch(params.id)}>Retry</Button></div>}
      {ready && <>
        <header className="fm-match-heading"><h4 className="mb-0">Friendly Match {friendlyId(match)}</h4>
          <span className="badge badge-light">{matchStatus(match)}</span>

        </header>
        <div className="mt-2"><ResultStatus match={match} /></div>
        {match.resultValidation?.source === "administrator" && <p>Administrative validation: {friendlyDate(match.resultValidation.appliedAt, "UTC")}</p>}
        <MatchParticipants match={match} details />
        {(match.matches?.length > 1 || match.resultVerification) && <p className="alert alert-warning">The ranking result cannot be identified uniquely. Points are not displayed.</p>}
        <dl className="fm-metadata mt-3">{fields.map(([label, value]) => <div key={label}><dt>{label}</dt><dd className={label === "Sport / Game type" ? "text-capitalize" : undefined}>{value}</dd></div>)}</dl>
        {match.bookingId && <p className="alert alert-info">Court booking is managed separately in the booking workflow.</p>}
        <details><summary>Technical details</summary><div>Match ID: {match._id}</div>{match.bookingId && <div>Booking ID: {match.bookingId}</div>}</details>
      </>}
      {String(match._id) === params.id && <Administration match={match} ready={ready} onSaved={() => getFriendlyMatch(params.id)} />}
    </CardBody></Card>
    {ready && <AppliedChanges key={`applied:${params.id}`} matchId={params.id} matchStatus={match.status} />}
    {ready && <ActionLogs key={params.id} matchId={params.id} />}
  </Container></div></PlayerRatingScope>
}
export default connect(({ friendlyMatches = {} }) => ({ friendlyMatchesState: friendlyMatches }), { getFriendlyMatch: actions.getFriendlyMatch })(Details)
